import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { setContext } from '@apollo/client/link/context';
var customHeaders = {};
export var CLIENT_END_POINTS = {
  ONE_GRAPH: {
    dev: 'https://gateway.dev.cheggnet.com/one-graph/graphql',
    test: 'https://gateway.test.cheggnet.com/one-graph/graphql',
    stage: 'https://gateway.stage.chegg.com/one-graph/graphql',
    prod: 'https://gateway.chegg.com/one-graph/graphql'
  },
  LPC_BFF: {
    dev: 'https://gateway.dev.cheggnet.com/landing-pages-contentful-bff/graphql',
    test: 'https://gateway.test.cheggnet.com/landing-pages-contentful-bff/graphql',
    stage: 'https://gateway.stage.chegg.com/landing-pages-contentful-bff/graphql',
    prod: 'https://gateway.chegg.com/landing-pages-contentful-bff/graphql'
  }
};
export var authLink = setContext(function (_, _ref) {
  var headers = _ref.headers;
  // return the headers to the context so httpLink can read them
  return {
    headers: _objectSpread(_objectSpread({}, headers), customHeaders)
  };
});
export var setCustomHeader = function setCustomHeader(name, value) {
  customHeaders[name] = value;
};